<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>
        <v-autocomplete
          v-model="provider.localisation.commune"
          :class="{'no-detail': suggestedCommune !== null,
                     'input-error': submitted && field.required && (provider.localisation.commune === null || provider.localisation.commune === '')}"
          :items="communes"
          item-text="name"
          return-object
          :loading="loadingCommunes"
          :search-input.sync="search"
          no-data-text="Saisissez pour sélectionner une ville"
          outlined
          hide-details>
        </v-autocomplete>

        <v-expand-transition>
            <city-suggestion class="mt-5" v-if="suggestedCommune !== null"></city-suggestion>
        </v-expand-transition>
    </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from "vuex"
import {latLng} from "leaflet"
import _ from "lodash"
import {fieldsMapping} from "../../../../static/webform"

import HelpTooltip from "../../../tools/HelpTooltip.vue"
import CitySuggestion from "../suggestion/CitySuggestion.vue"

export default {
    name: "FormCity",
    components: {CitySuggestion, HelpTooltip},
    props: ['field'],
    data() {
        return {
            loadingCommunes: false
        }
    },
    methods: {
        ...mapMutations('web_form', ['setCommunes', 'pushCommune', 'setSearchCommunes']),
        getCommunes: _.debounce(function () {
            this.loadingCommunes = true

            let payload = {
                search: this.searchCommunes
            }

            this.$http.post('resource/communes', payload).then(res => {
                this.setCommunes(res.body.data.communes)

                this.loadingCommunes = false
            })
        }, 500)
    },
    watch: {
        searchCommunes() {
            if (this.searchCommunes) {
                this.setSearchCommunes(this.searchCommunes.toUpperCase())
            } else {
                this.setSearchCommunes(null)
                this.provider.localisation.commune = null
            }

            this.getCommunes()
        }
    },
    mounted() {
        if (this.provider.localisation && this.provider.localisation.commune !== undefined && this.provider.localisation.commune !== null) {
            this.pushCommune(this.provider.localisation.commune)
            this.setSearchCommunes(this.provider.localisation.commune.name)
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", 'primaryColor']),
        ...mapState("web_form", ['submitted', 'provider', 'suggestedCommune', 'communes', 'searchCommunes']),
        search: {
            get () {
                return this.searchCommunes
            },

            set (searchInput) {
                this.setSearchCommunes(searchInput)
            }
        }
    }
}
</script>